import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';
import { FormattedMessage, defineMessages } from 'react-intl';
import styled from 'styled-components';

import { StarBall } from '@sorare/core/src/atoms/icons/StarBall';
import { useIntlContext } from '@sorare/core/src/contexts/intl';

import type { PostExcerpt_Meta } from './__generated__/index.graphql.ts';

const metaFragment = gql`
  fragment PostExcerpt_Meta on Post {
    databaseId
    date
    content
    author {
      node {
        name
      }
    }
  }
` as TypedDocumentNode<PostExcerpt_Meta>;

const messages = defineMessages({
  readingTime: {
    id: 'blog.readingTime',
    defaultMessage: '{min} min read',
  },
});

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 1em;
  font-size: 0.8em;
  color: var(--c-nd-800);
`;

const WORDS_PER_MINUTE = 185;

type Props = {
  excerpt: PostExcerpt_Meta;
};

export const Meta = ({ excerpt }: Props) => {
  const { locale } = useIntlContext();
  const date = new Date(Date.parse(excerpt.date!));
  const min = Math.ceil(
    (excerpt.content || '').split(/\s+/).length / WORDS_PER_MINUTE
  );
  const author = excerpt.author!.node!;

  return (
    <Wrapper>
      <StarBall height={44} width={44} />
      <div>
        <div>{author.name}</div>
        <div>
          {date.toLocaleDateString(locale, {
            day: 'numeric',
            month: 'short',
            year:
              date.getFullYear() === new Date().getFullYear()
                ? undefined
                : 'numeric',
          })}
          {' · '}
          <FormattedMessage {...messages.readingTime} values={{ min }} />
        </div>
      </div>
    </Wrapper>
  );
};

Meta.fragment = metaFragment;
